/**
 * Maps a blank or whitespace-only form field to `undefined` so a request body omits the key
 * entirely.
 *
 * `undefined` rather than `null` or `''` is load-bearing: the admin update endpoints filter the
 * request body to truthy values and reject a body with no truthy field, so an empty optional
 * must be absent rather than present-and-empty.
 */
export const blankToUndefined = (value: string): string | undefined => {
  const trimmed = value.trim()

  return trimmed === '' ? undefined : trimmed
}
